import classNames from 'classnames'
import { MdOutlineSearch } from 'react-icons/md'

import type { ChangeEvent, ReactElement } from 'react'

import TextInput from '../TextInput'

export interface Props {
  autoFocus?: boolean
  className?: string
  defaultValue?: string
  disabled?: boolean
  id?: string
  onChange: (evt: ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  size?: Exclude<SIZES, 'large'>
  value?: string
}

const SearchInput = ({
  autoFocus,
  className,
  defaultValue,
  disabled,
  id,
  onChange,
  placeholder = 'Search',
  size = 'medium',
  value,
}: Props): ReactElement => {
  return (
    <TextInput
      autoFocus={autoFocus}
      className={classNames('search-input-component', className)}
      defaultValue={defaultValue}
      disabled={disabled}
      icon={<MdOutlineSearch size={16} />}
      id={id}
      onChange={onChange}
      placeholder={placeholder}
      size={size}
      value={value}
    />
  )
}

export default SearchInput
